// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"8889a67f","498":"807fb984","513":"8b0c7035","787":"0c372db0"}[chunkId] + ".chunk.js";
};